import { z } from 'zod';
import { localizedStringSchema } from '../localized-string.js';
import { paymentStatusSchema } from './public-booking.js';

export const paymentsAccountSchema = z.object({
  connected: z.boolean(),
  configured: z.boolean(),
  accountId: z.string().nullable(),
  livemode: z.boolean().nullable(),
  chargesEnabled: z.boolean(),
  payoutsEnabled: z.boolean(),
  defaultCurrency: z.string().nullable(),
  country: z.string().nullable(),
  connectedAt: z.string().datetime().nullable(),
  dashboardUrl: z.string().nullable(),
});
export type PaymentsAccount = z.infer<typeof paymentsAccountSchema>;

export const transactionSchema = z.object({
  bookingId: z.string(),
  start: z.string().datetime(),
  bookerName: z.string(),
  bookerEmail: z.string(),
  eventTypeName: localizedStringSchema,
  amount: z.number().int(),
  currency: z.string(),
  status: paymentStatusSchema,
  refundedAmount: z.number().int(),
  paidAt: z.string().datetime().nullable(),
  receiptUrl: z.string().nullable(),
});
export type Transaction = z.infer<typeof transactionSchema>;

export const transactionListSchema = z.object({
  items: z.array(transactionSchema),
  nextCursor: z.string().nullable(),
  totals: z.object({
    paid: z.number().int(),
    refunded: z.number().int(),
    currency: z.string().nullable(),
  }),
});

export const transactionListQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export const manualRefundInputSchema = z.object({
  /** Minor units; omit for the full remaining amount. */
  amount: z.number().int().positive().optional(),
});
